import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session/session';

export const mfaFlowGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  const flow = session.getFlow();

  if (!flow) {
    return router.createUrlTree(['/login']);
  }

  return true;
};
